var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_912_8304",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 17,
    width: 96,
    height: 88
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 17.5H107.499V104.902H12.5V17.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_912_8304)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2115 99.9022H100.789L59.999 25.1221L19.2115 99.9022ZM104.999 104.902H14.999C14.119 104.902 13.3015 104.437 12.849 103.677C12.399 102.92 12.384 101.98 12.804 101.205L57.8065 18.7046C58.679 17.0971 61.3215 17.0971 62.194 18.7046L107.194 101.205C107.617 101.98 107.599 102.92 107.152 103.677C106.699 104.437 105.882 104.902 104.999 104.902Z",
    fill: "#FFC828"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0439 71.185C58.6614 71.185 57.5439 70.065 57.5439 68.685V46.04C57.5439 44.66 58.6614 43.54 60.0439 43.54C61.4264 43.54 62.5439 44.66 62.5439 46.04V68.685C62.5439 70.065 61.4264 71.185 60.0439 71.185Z",
    fill: "#FFC828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0439 93.8309C58.6614 93.8309 57.5439 92.7109 57.5439 91.3309V83.6709C57.5439 82.2909 58.6614 81.1709 60.0439 81.1709C61.4264 81.1709 62.5439 82.2909 62.5439 83.6709V91.3309C62.5439 92.7109 61.4264 93.8309 60.0439 93.8309Z",
    fill: "#FFC828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.14ca212b6af779e09a0bccefecfdfb3d.svg";
export { ForwardRef as ReactComponent };